import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_2 = { class: "p-field p-col-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "p-field p-col-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "timespan-type-value" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = { class: "p-field p-col-4" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      (_ctx.timespan)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.timespan.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.timespan.name = $event)),
                  maxLength: "100",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('touched')))
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " *", 1)
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.timespan.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.timespan.type = $event)),
                  options: _ctx.timespanDescriptor.typeValues,
                  optionValue: "value",
                  optionLabel: "label",
                  onChange: _ctx.onTypeChange
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode("span", _hoisted_8, _toDisplayString(slotProps.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("span", null, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onChange"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.type')) + " *", 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_Dropdown, {
                  class: "kn-material-input",
                  modelValue: _ctx.timespan.category,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.timespan.category = $event)),
                  options: _ctx.categories,
                  optionValue: "VALUE_ID",
                  optionLabel: "VALUE_NM",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched')))
                }, null, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.category')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}